import { render } from "./ChatwallContent.vue?vue&type=template&id=b236c0fe"
import script from "./ChatwallContent.vue?vue&type=script&lang=js"
export * from "./ChatwallContent.vue?vue&type=script&lang=js"

import "./ChatwallContent.vue?vue&type=style&index=0&id=b236c0fe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__